import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getSummary(): Observable<any> {
    return this.http.get<any>(this.apiUrl + '/admin/analytics/summary');
  }

  getTrends(days = 7): Observable<any> {
    return this.http.get<any>(this.apiUrl + '/admin/analytics/trends/' + days);
  }

  syncAnalytics(days = 90): Observable<any> {
    return this.http.get<any>(this.apiUrl + '/admin/analytics/sync/' + days);
  }
}
